<template>
  <section class="unit bg-light unit-details-container">
    <div class="container-fluid details-card">
      <h3 class="fw-bold mb-3 mb-lg-2"> <i class="bi bi-buildings"></i> {{ details.project_name }} </h3>
      <div class="d-flex flex-column flex-lg-row justify-content-lg-between gap-4 mb-4">
        <div class="d-flex flex-column flex-lg-row gap-2 gap-lg-4">
          <a href="#"><i class="bi bi-geo-alt"></i> {{ details.project_address }}</a>
        </div>
      </div>

      <div class="col-12">
        <div class="row">

          <div class="col-xxl-8 col-xl-8 col-lg-12 col-md-12">
            <div id="unitDetailsImages" class="carousel slide unit-details-carousel" data-bs-touch="false">
              <!---style="position: absolute;"-->
              <div class="carousel-indicators unit-details-indicators">
                <div v-for="(imgs, index) in !details.unit_images ? details.unit_images : details.unit_images.split(',')">
                  <button v-if="index == 0" type="button" data-bs-target="#unitDetailsImages" :data-bs-slide-to="index"
                    class="active" aria-current="true" :aria-label="'Slide ' + index + 1">
                    <img :src="url + imgs" class="d-block w-100 img-fluid" alt="...">
                  </button>
                  <button v-else type="button" data-bs-target="#unitDetailsImages" :data-bs-slide-to="index"
                    :aria-label="'Slide ' + index + 1">
                    <img :src="url + imgs" class="d-block w-100 img-fluid" alt="...">
                  </button>
                </div>
              </div>
              <div class="carousel-inner">
                <div v-for="(imgs, index) in !details.unit_images ? details.unit_images : details.unit_images.split(',')">
                  <div class="carousel-item unit-image-item active" v-if="index == 0">
                    <img :src="url + imgs" class="img-fluid" alt="...">
                  </div>
                  <div class="carousel-item unit-image-item " v-else>
                    <img :src="url + imgs" class="img-fluid" alt="...">
                  </div>
                </div>
              </div>
              <button class="carousel-control-prev" type="button" data-bs-target="#unitDetailsImages"
                data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
              </button>
              <button class="carousel-control-next" type="button" data-bs-target="#unitDetailsImages"
                data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>

          <div class="col-xxl-4 col-xl-4 col-lg-12 col-md-12 details-card-info">

            <div class="col-12">
              <div class="mb-4">
                <h5 class="fw-bold mb-2"><i class="bi bi-credit-card-2-front"></i> {{ details.unit_number }}
                </h5>
                <p class="d-flex flex-column flex-lg-row gap-0 gap-lg-3 mb-0">
                  <span>{{ details.max_adult + details.max_child }} guests <i class="bi bi-dot"></i> {{
                    details.max_adult }} adults <i class="bi bi-dot"></i> {{ details.max_child }}
                    children</span>
                </p>
              </div>
              <div class="mb-5">
                <p class="mb-3 mb-md-4">
                  {{ details.unit_description }}
                </p>
              </div>

              <div class="pt-0">
                <h5 class="fw-bold mb-3 mb-md-4">What this place offers</h5>
                <div class="row gx-3 gy-2 mb-3 mb-md-4">
                  <div class="amenities">
                    <div class="box" v-for="item in project_amenities">
                      <p><i class="fas fa-check-circle text-success"></i>{{ item.amenityName }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- payment card -->
            <div class="col-12">
              <div class="col payment-card">
                <div class="card border bg-white" style="padding-left: 20px; padding-right: 20px;">
                  <div class="mx-4 mx-lg-0 my-4 my-lg-5">
                    <form
                      @submit.prevent="redirectToBooking(details.unit_code, date_from, date_to, adult_count, child_count)">
                      <div class="d-flex justify-content-between align-items-end gap-4 mb-3 mb-md-4">
                        <div class="d-flex align-items end gap-2">
                          <h5 class="fw-bold mb-0">₱{{ formatCurrency(details.rate_amount) }}</h5>
                          <span style="line-height: 1.4">/day</span>
                        </div>
                      </div>

                      <div class="row g-2 mb-2">
                        <div class="col-lg-6">
                          <input class="form-control date-input" id="date_from" v-model="date_from" type="date" />
                        </div>
                        <div class="col-lg-6">
                          <input class="form-control date-input" id="date_to" v-model="date_to" type="date" />
                        </div>
                      </div>

                      <div class="mb-3">
                        <div class="dropdown">
                          <button class="btn btn-default text-start w-100 dropdown-toggle" type="button"
                            data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false">
                            <div class="d-flex justify-content-between gap-4">

                              <div v-if="total_count == 0">Add guests</div>

                              <div v-else>
                                <span v-if="total_count <= 1">{{ total_count }} guest</span>
                                <span v-else>{{ total_count }} guests</span>
                              </div>

                              <a href="#" v-if="total_count != ''"
                                @click.prevent="(adult_count = 1), (child_count = 0), (total_count = 0)">
                                <i class="fas fa-times"></i>
                              </a>
                            </div>
                          </button>
                          <div class="dropdown-menu dropdown-menu-end dropdown-menu-guest p-3">
                            <div class="text-muted d-flex justify-content-between gap-4 mb-3">
                              Guest
                              <span v-if="adult_count != 1 || child_count != 0">
                                <a href="#" role="button"
                                  @click.prevent="(adult_count = 1), (child_count = 0), (total_count = 0)">
                                  Clear
                                </a>
                              </span>
                            </div>
                            <div class="d-flex flex-column gap-3">
                              <div class="d-flex justify-content-between align-items-end gap-3 gap-lg-5">
                                <div class="d-flex flex-column">
                                  <span class="fw-bold">Adults</span>
                                  <span class="small text-muted" style="white-space: nowrap">
                                    Ages 13 or above
                                  </span>
                                </div>
                                <div class="d-inline-block">
                                  <div class="d-flex flex-nowrap">
                                    <button class="btn btn-default btn-icon btn-icon-xs" type="button"
                                      :disabled="adult_count <= 1" @click="subtractAdultCount(1); addTotalCount();">
                                      <i class="fas fa-minus fa-sm"></i>
                                    </button>
                                    <input type="text" v-model="adult_count"
                                      class="form-control form-control-xs bg-white text-center"
                                      style="width: 35px; background-color: transparent !important; border-color: transparent !important; box-shadow: none !important;"
                                      readonly />
                                    <button class="btn btn-default btn-icon btn-icon-xs" type="button"
                                      :disabled="details.max_adult <= adult_count"
                                      @click="addAdultCount(1); addTotalCount()">
                                      <i class="fas fa-plus fa-sm"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div class="d-flex justify-content-between align-items-end gap-3 gap-lg-5">
                                <div class="d-flex flex-column">
                                  <span class="fw-bold">Children</span>
                                  <span class="small text-muted" style="white-space: nowrap">Ages
                                    2-12</span>
                                </div>
                                <div class="d-inline-block">
                                  <div class="d-flex flex-nowrap">
                                    <button class="btn btn-default btn-icon btn-icon-xs" type="button"
                                      :disabled="child_count <= 0" @click="subtractChildCount(1); addTotalCount();">
                                      <i class="fas fa-minus fa-sm"></i>
                                    </button>
                                    <input type="text" value="0" class="form-control form-control-xs bg-white text-center"
                                      style="width: 35px; background-color: transparent !important; border-color: transparent !important; box-shadow: none !important;"
                                      readonly v-model="child_count" />
                                    <button class="btn btn-default btn-icon btn-icon-xs" type="button"
                                      :disabled="details.max_child <= child_count"
                                      @click="addChildCount(1); addTotalCount();">
                                      <i class="fas fa-plus fa-sm"></i>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="!is_dates_set" class="border rounded p-3 mb-3">
                        <i class="fas fa-exclamation-circle text-danger me-3"></i>Please select
                        dates first
                      </div>
                      <button class="btn w-100 mb-3" style="background-color: #1eacff; color: white;" type="submit">
                        <span v-if="date_from != '' && date_to != ''">Reserve</span>
                        <span v-else>Set Dates</span>
                      </button>
                    </form>
                    <div class="text-center small text-muted mb-3 mb-md-4">
                      You won't be charged yet
                    </div>
                    <div class="d-flex flex-column gap-2">
                      <div class="d-flex justify-content-between gap-4 w-100">
                        <span>Accommodation</span>
                        <span class="text-dark">₱{{ formatCurrency(details.rate_amount) }}</span>
                      </div>
                    </div>
                    <div class="border-top my-3" style="height: 1px"></div>
                    <div class="d-flex justify-content-between gap-4 w-100">
                      <span class="text-dark">Total</span>
                      <span class="fw-bold text-dark">₱{{ formatCurrency(details.rate_amount) }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import "@/assets/css/unit.css";
import Flickity from 'vue-flickity';

export default {
  components: {
    Flickity
  },
  name: "Unit",
  props: {
    type: Number,
    required: true,
  },
  data: () => ({
    flickityOptions: {
      initialIndex: 3,
      prevNextButtons: true,
      pageDots: true,
      wrapAround: true,
      freeScroll: true
      // any options from Flickity can be used
    },
    url: process.env.VUE_APP_API_URL,
    project_amenities: [],
    arr_unit_details: [],
    details: {
      unit_code: "",
      project_name: "",
      project_address: "",
      unit_number: "",
      unit_description: "",
      max_adult: 0,
      max_child: 0,
      rate_amount: 0,
      unit_images: ""
    },
    image: {
      first_image: "",
      second_image: "",
      third_image: "",
      fourth_image: "",
      fifth_image: "",
    },
    date_from: "",
    date_to: "",
    adult_count: 1,
    child_count: 0,
    total_count: 0,
    is_dates_set: true,
  }),
  mounted() {
    this.details.unit_code =
      this.$route.params.str_unit_code != null ? this.$route.params.str_unit_code : 0;
    this.date_from =
      this.$route.query.check_in != null
        ? this.$route.query.check_in
        : startDate.toISOString().split("T")[0];
    this.date_to = this.$route.query.check_out != null ? this.$route.query.check_out : "";

    this.adult_count =
      this.$route.query.adult != null ? parseInt(this.$route.query.adult) : 1;
    this.child_count =
      this.$route.query.child != null ? parseInt(this.$route.query.child) : 0;

    this.getUnitDetails();
    this.addTotalCount();
  },
  updated() {
    $(".owl-carousel").owlCarousel({
      loop: false,
      margin: 16,
      nav: true,
      dots: false,
      responsive: {
        0: {
          items: 1,
          margin: 8,
        },
        576: {
          items: 1,
          margin: 8,
        },
        768: {
          items: 2,
          margin: 8,
        },
        992: {
          items: 2,
          margin: 16,
        },
        1200: {
          items: 2,
          margin: 16,
        },
      },
    });
  },
  methods: {
    addTotalCount() {
      this.total_count = this.adult_count + this.child_count;
    },
    addAdultCount: function (inc) {
      if (this.details.max_adult > this.adult_count) {
        this.adult_count += inc;
      }
    },
    subtractAdultCount: function (dec) {
      if (this.adult_count > 1) {
        this.adult_count -= dec;
      }
    },
    addChildCount: function (inc) {
      if (this.details.max_child > this.child_count) {
        this.child_count += inc;
      }
    },
    subtractChildCount: function (dec) {
      if (this.child_count > 0) {
        this.child_count -= dec;
      }
    },
    redirectToBooking(unitCode, dateFrom, dateTo, adultCount, childCount) {
      if (this.date_from != "" && this.date_to != "") {
        this.changeQueryString();
        this.$router.push({
          name: "Book",
          params: {
            str_unit_code: unitCode,
          },
          query: {
            check_in: dateFrom || undefined,
            check_out: dateTo || undefined,
            adult: adultCount || undefined,
            child: childCount || undefined,
          },
        });
        this.is_dates_set = true;
      } else if (this.date_from == "" && this.date_to == "") {
        $("#date_from").focus();
        this.is_dates_set = false;
      } else if (this.date_from == "" && this.date_to != "") {
        $("#date_from").focus();
        this.is_dates_set = false;
      } else if (this.date_from != "" && this.date_to == "") {
        $("#date_to").focus();
        this.is_dates_set = false;
      }
    },
    async getUnitDetails() {
      const res = await axios.get(this.url + "/api/units/unit", {
        params: {
          strUnitCode: this.details.unit_code,
        },
      });
      this.arr_unit_details = JSON.parse(res.data);
      this.getRoomAmenities(this.arr_unit_details[0].ProjectCode)
      this.details.project_name = this.arr_unit_details[0].ProjectName;
      this.details.project_address = this.arr_unit_details[0].ProjectAddress;
      this.details.unit_description = this.arr_unit_details[0].UnitDescription;
      this.details.unit_number = this.arr_unit_details[0].UnitNumber;
      this.details.max_adult = this.arr_unit_details[0].MaxAdult;
      this.details.max_child = this.arr_unit_details[0].MaxChild;
      this.details.unit_images = this.arr_unit_details[0].UnitImages;
      this.details.rate_amount = parseInt(
        this.arr_unit_details[0].RateAmount == null ? 0 : this.arr_unit_details[0].RateAmount.replace(",", "")
      );

      const path = this.url + "/assets/images/";

      // this.image.first_image = path + this.arr_unit_details[0].UnitImage;
      // this.image.second_image = path + this.arr_unit_details[0].UnitImage_2;
      // this.image.third_image = path + this.arr_unit_details[0].UnitImage_3;
      // this.image.fourth_image = path + this.arr_unit_details[0].UnitImage_4;
      // this.image.fifth_image = path + this.arr_unit_details[0].UnitImage_5;
      console.log(this.arr_unit_details[0])
    },
    async getRoomAmenities(proj_code) {
      const res = await axios.get(this.url + "/api/roomamenities/details?", {
        params: {
          projectcode: proj_code,
          recordID: 1
        },
      });
      this.project_amenities = (res.data.data);
    },
    formatCurrency(val) {
      if (val !== null) {
        return val.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      }
    },
    changeQueryString() {
      this.$router.replace({
        query: {
          check_in: this.date_from || undefined,
          check_out: this.date_to || undefined,
          adult: this.adult_count || undefined,
          child: this.child_count || undefined,
        },
      });
    },
  },
};
</script>
